import {DeviceDetailActionType, constants} from '../assets/constants/constants';
import {UserDetailsType, VerificationCodeType} from './../interface';
import Api from './index';
import { BASE_URL, endPoints, ALM_URL } from "./urls";

export const getSllUser = async (email: any) => {
  try {
    return await Api().get(`${BASE_URL}${endPoints.USER_ROUTE}?email=${encodeURIComponent(email.toLowerCase())}`);
  } catch (e) {
    console.log('error in getSllUser : ', e);
    return e;
  }
};

export const socialSignInUser = async () => {
  try {
    return await Api().post(`${BASE_URL}${endPoints.USER_SOCIAL_SIGN_IN}`);
  } catch (e) {
    console.log('error in socialSignInUser : ', e);
    return e;
  }
};

export const userVerificationCode = async (data: VerificationCodeType) => {
  try {
    return await Api().post(`${BASE_URL}${endPoints.USER_VERIFICATION_CODE}`, data);
  } catch (e) {
    console.log('error in userVerificationCode : ', e);
    return e;
  }
};

export const updateUserProfile = async (data: UserDetailsType) => {
  try {
    return await Api().patch(`${BASE_URL}${endPoints.USER_ROUTE}`, data);
  } catch (e) {
    console.log('error in updateUserProfile : ', e);
    return e;
  }
};

export const getAlmToken = async () => {
  try {
    return await Api().get(`${BASE_URL}${endPoints.ALM_TOKEN}`);
  } catch (e) {
    console.log('error in getAlmToken : ', e);
    return e;
  }
};

export const deviceDetails = async (type = constants.logout) => {
  try {
    const data = {
      deviceIdentifier: constants.WEB,
      deviceType: constants.DEVICE_TYPE,
      deviceModel: constants.DEVICE_MODEL,
      actionType: DeviceDetailActionType[type],
      logoutAllDevice: type === constants.logout ? true : false,
    };
    return await Api().post(`${BASE_URL}${endPoints.DEVICE_DETAIL}`, data);
  } catch (e) {
    console.log('error in deviceDetails : ', e);
    return e;
  }
};

export const courseComplete = async (loResourceGradesData: any) => {
  try {
    return await Api().post(`${BASE_URL}${endPoints.COURSE_COMPLETE}`, loResourceGradesData);
  } catch (e) {
    console.log('error in courseComplete : ', e);
    return e;
  }
};

export const getLottieFileContent = async (location: string | undefined) => {
  try {
    return await Api().post(`${BASE_URL}${endPoints.READ_FILE}`, {location: location});
  } catch (e) {
    console.log('error in getLottieFileContent : ', e);
    return e;
  }
};

export const getExerciseCourse = async (courseId: string,exerciseModule:[]) => {
  try {
      return await Api().get(`${BASE_URL}${endPoints.EXERCISE_COURSE}/${courseId}${exerciseModule.length ? `?moduleId=${exerciseModule}`:''}`);
  } catch (e) {
      console.log('error in getExerciseCourse : ', e);
      return e;
  }
};

export const postExerciseCourse = async (courseId: string, params: any) => {
  try {
      return await Api().post(`${BASE_URL}${endPoints.EXERCISE_COURSE}/${courseId}`, params);
  } catch (e) {
      console.log('error in postExerciseCourse : ', e);
      return e;
  }
}

export const getUserNotificationSettings = async () => {
  try {
    return await Api().get(`${BASE_URL}${endPoints.USER_SETTING}`);
  } catch (e) {
    console.log('error in getUserNotificationSettings : ', e);
    return e;
  }
};

export const updateUserNotificationSettings = async (patchData: {
  enableOtherNotification: number;
  enableDailyRemainder: number;
}) => {
  try {
    return await Api().patch(`${BASE_URL}${endPoints.USER_SETTING}`, patchData);
  } catch (e) {
    console.log('error in updateUserNotificationSettings : ', e);
    return e;
  }
};

export const updateLanguageSetting = async (locale: any) => {
  try {
    return await Api().patch(`${BASE_URL}/user/setting`, {local: locale});
  } catch (e) {
    console.log('error in language setting : ', e);
    return e;
  }
};

export const deleteAvatarImage = async () => {
  const response = await Api(true).delete(
    `${ALM_URL}${endPoints.ALM_AVATAR_DELETE}`
  );
  const result = response;
  return result;
};

export const getUserData = async () => {
  try {
    const response = await Api(true).get(`${ALM_URL}${endPoints.USER_ROUTE}`);
    return response.data; // Return just the data part of the response
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};
export const getMultileExerciseStatus = async (ids:any)=>{
    
  try {
      const response = await Api().get(`${BASE_URL}${endPoints.exerciseMultipleCourse}/?courseIds=${ids}`)
      const result = response;
      return result;

  }catch(e){
      console.log("error fetching members by exercises", e)
      return e;
  }
}


export const policyTermCondition = async (isLoggedIn: boolean = false) => {
    try {
      const config: any = {}; // Default config object for the API call

      if (isLoggedIn) {
        const accessToken = localStorage.getItem("access_token"); // Check for access_token
        const token = localStorage.getItem("token"); // Check for fallback token (if required)

        if (accessToken) {
          config.headers = {
            ...config.headers,
            Authorization: `Bearer ${accessToken}`,
          };
        } else if (token) {
          config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
          };
        }
      }

      // Make the API call with the optional config (headers with token if logged in)
      const response = await Api().get(
        `${BASE_URL}${endPoints.POLICY_AND_TERM_CONDITION}`,
        config
      );
      return response;
    } catch (error) {
      console.error("Error fetching policy term condition:", error);
      return error;
    }
};

export const getPostComments = async (postId:any, offset:any) => {
  try {
      const response = await Api().get(`${BASE_URL}${endPoints.POST_COMMENTS}?postId=${postId}&offset=${offset}&limit=${10}`)
      return response
  } catch (e) {
      return e
  }
}

export const getCommentsReplies = async (commentId:any,offset:any) => {
  try {
      const response = await Api().get(`${BASE_URL}${endPoints.POST_REPLIES}?commentId=${commentId}&offset=${offset}&limit=${10}`)
      return response
  } catch (e) {
      return e
  }
}

export const fetchLanguages = async () => {
  try {
      const response = await Api().get(`${BASE_URL}${endPoints.activeLanguages}`)
      const result = response;
      return result;
  } catch (e) {
      console.log('error in fetchLanguages : ', e);
      return e;
  }
}

export const registrationCompleted = async ()=>{
  try {
      const response = await Api().patch(`${BASE_URL}${endPoints.REGISTRATION_COMPLETED}`)
      const result = response;
      return result;
  }catch(e){
      console.log("error in registrationCompleted api", e)
      return e;
  }
}

export const updateAvatarUrl = async () => {
  try {
      const response = await Api().patch(`${BASE_URL}${endPoints.AVATAR_URL_UPDATE}`)
      return response
  } catch (e) {
      console.log("errorrr", e)
      return e
  }
}
export const completLiveClassMeeting = async (cId:any) => {
  try {
      const response = await Api().post(`${BASE_URL}${endPoints.MEETINGCOMPLETE}/${cId}`)
      return response
  } catch (e) {
      return e
  }
}
export const userAvatarurlUpdate = async () => {
  const response = await Api().patch(`${BASE_URL}${endPoints.USER_AVATARURL_UPDATE}`);
  const result = response;
  return result;
};
export const sendStorageToBakend = async (allStorageValues:any) => {
  try {
    return await Api().post(`${BASE_URL}${endPoints.STORAGE_TO_BAKEND}`,{localStorage:allStorageValues});
  } catch (e) {
    console.log('error in getAlmToken : ', e);
    return e;
  }
};

export const getUserConfirmation = async (email: string) => {
  try {
      const response = await Api().post(`${BASE_URL}${endPoints.USER_CONFIRMATION}`,{email:email})
      return response
  } catch (e) {
      return e
  }
}
export const ResendInvite = async (email: string) => {
  try {
      const response = await Api().post(`${BASE_URL}${endPoints.RESEND_INVITE}`, { username: email })
      return response
  } catch (e) {
      return e
  }
}

export const handleChainLitChatBot=async()=>{
  const response = await Api().get(`${BASE_URL}${endPoints.CHAINLIT_TOKEN_GENERATION}`)
  const result = response;
  return result;
}

export const getCorporateAccountStatus = async () => {
  try {
    const response = await Api().get(
      `${BASE_URL}${endPoints.USER_CORPORATE_ACCOUNT_ACTIVE_STATUS}`
    );
    return response?.status;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};
export const setLocalStorageData = async() => {
    try {
        const response = await Api().get(`${BASE_URL}${endPoints.STORAGE_TO_BAKEND}`)
        return response
    } catch (error) {
        console.log("error while fething localstorage variables",error)
        throw error;
    }
}